import { render, staticRenderFns } from "./Kastelweg.vue?vue&type=template&id=4eaa2ce9&"
import script from "./Kastelweg.vue?vue&type=script&lang=ts&"
export * from "./Kastelweg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports